<template>
    <page-view title="">
        <template slot="action">

        </template>
        <a-spin tip="正在加载包组数据..." :spinning="spinning">
            <div class="text-right pt-5 mb-5">
                <a-button class="" type="primary" icon="plus-circle" @click="onSave" :loading="loading">保存包组</a-button>
            </div>
        <a-card>
            <a-form :form="packEditForm" class="pick-100">
                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="11">
                        <a-form-item label="包组名称">
                            <a-input placeholder="包组名称"
                                     v-decorator="['packName',{initialValue:packDataModel.pack_name, rules: [{ required: true, message: '请输入包组名称',whitespace:true }]}]"></a-input>
                        </a-form-item>
                    </a-col>
<!--                    @blur.native.capture="onChangeCode"-->
                    <a-col :span="11">
                        <a-form-item label="包组编号">
                            <a-input placeholder="包组编号" readOnly
                                     v-decorator="['packCode',{initialValue:packDataModel.pack_code}]"></a-input>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="采购品目">
                            <div class="d-flex">
                                <a-input placeholder="请选择采购品目" disabled  v-decorator="['purchaseTypeName',{initialValue:packDataModel.purchase_type_name,rules: [{ required: isRequired, message: '请选择采购品目' }]}]" />
                                <a-button type="primary" @click="openChoosePurchaseTypeMethod">选择</a-button>
                            </div>
                             <a-input  style="display:none"
                                     v-decorator="['purchaseType',{initialValue:packDataModel.purchase_type,rules: [{ required: isRequired, message: '请选择采购品目' }]}]"></a-input>
                           <!-- <dict-cascader dictKey="PROJECT.TYPE" placeholder="请选采购品目"
                                           v-decorator="['purchaseType',{initialValue:packDataModel.purchase_type,rules: [{ required: isRequired, message: '请输入采购品目' }]}]"/>-->
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="24">
                        <a-divider class="color-orange" orientation="left">竞价要求</a-divider>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="竞价方式">
                            <a-radio-group @change="e=> jingjiaWayChange(e.target.value)"
                                    v-decorator="['jingjiaWay',{initialValue:packDataModel.jingjia_way}]">
                                <a-radio value="1">自由竞价</a-radio>
                                <a-radio value="2">单轮竞价</a-radio>
                                <!-- <a-radio value="3">多轮竞价</a-radio> -->
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                      <a-form-item label="报价类型">
                        <a-radio-group @change="e=> onChangeOfferType(e.target.value,'offer_type')"
                            v-decorator="['offerType',{initialValue:packDataModel.offer_type}]">
                            <a-radio value="1">金额</a-radio>
                            <a-radio value="2">折扣率</a-radio>
                            <a-radio value="3">下浮率</a-radio>
                        </a-radio-group>
                      </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="竞价类型">
                            <a-radio-group @change="e=> jingjiaTypeChange(e.target.value)"
                                    :disabled="packDataModel.offer_type!='1'"
                                    v-decorator="['jingjiaType',{initialValue:packDataModel.jingjia_type}]">
                                <a-radio value="2">竞低价</a-radio>
                                <a-radio value="1">竞高价</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="竞价时长">
                              <span class="d-inline-block">
                            <a-input-number placeholder="竞价时长" style="width: 250px"
                                            v-decorator="['duration',{ initialValue:packDataModel.duration,rules: [{ required: isRequired, message: '请输入竞价时长(分)' }]}]"
                                            :min="0"
                                            :precision="0"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">{{packDataModel.jingjia_way==='1'?'分钟':'分钟'}}</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11"  v-if="packDataModel.jingjia_way==='2'">
                        <a-form-item label="详细报价表" >
                                <span class="d-inline-block">
                                    <a-radio-group @change="e=> jingjiaDetailChange(e.target.value)"
                                        v-decorator="['jingjiaDetail',{initialValue:packDataModel.jingjia_detail}]">
                                        <a-radio value="1">需要</a-radio>
                                        <a-radio value="2">不需要</a-radio>
                                    </a-radio-group>
                                </span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11" v-if="packDataModel.jingjia_way==='2'">
                        <a-form-item label="报价确认函">
                                <span class="d-inline-block">
                                    <a-radio-group @change="e=> quotationConfirmChange(e.target.value)"
                                        v-decorator="['quotationConfirm',{initialValue:packDataModel.quotation_confirm}]">
                                        <a-radio value="1">需要</a-radio>
                                        <a-radio value="2">不需要</a-radio>
                                    </a-radio-group>
                                </span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11" v-if="packDataModel.jingjia_way==='1'">
                        <a-form-item label="倒计时时长" >
                               <span class="d-inline-block">
                            <a-input-number placeholder="倒计时时长" style="width: 250px"
                                            v-decorator="['countDown',{initialValue:packDataModel.count_down, rules: [{ required: isRequired, message: '请输入倒计时时长' }]}]"
                                            :min="0"
                                            :precision="0"
                            />
                                      </span>
                            <span class="d-inline-block" style="margin-left: 10px">分钟</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item  v-if="packDataModel.offer_type=='1'" :label="packDataModel.jingjia_type==='1'?'最低限价':'最高限价'">
                               <span class="d-inline-block">
                            <a-input-number :placeholder="packDataModel.jingjia_type==='1'?'最低限价':'最高限价'" style="width: 250px"
                                            v-decorator="['priceStart',{initialValue:packDataModel.price_start, rules: [{ required: isRequired, message: '请输入限价' }]}]"
                                            :min="0"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            />
                               </span>
                            <span class="d-inline-block" style="margin-left: 10px">元</span>
                        </a-form-item>
                        <a-form-item :label="packDataModel.jingjia_type==='1'?'最低限价':'最高限价'" v-else>
                              <span class="d-inline-block">
                                <a-input-number     :placeholder="packDataModel.jingjia_type==='1'?'最低限价':'最高限价'"
                                                      style="width: 250px"
                                                      v-decorator="['priceStart',{initialValue:packDataModel.price_start}]"
                                                      :min="0"
                                                      :precision="2"
                                                      :max="100"/>
                              </span>
                          <span class="d-inline-block" style="margin-left: 10px">%</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item v-if="packDataModel.jingjia_way==='1' && packDataModel.offer_type=='1'" :label="packDataModel.jingjia_type==='1'?'加价幅度':'减价幅度'">
                                 <span class="d-inline-block">
                            <a-input-number :placeholder="packDataModel.jingjia_type==='1'?'加价幅度':'减价幅度'"
                                            style="width: 250px"
                                            v-decorator="['pricePer',{ initialValue:packDataModel.price_per,rules: [{ required: isRequired, message: '请输入价格幅度' }]}]"
                                            :min="0"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">元</span>
                        </a-form-item>
                        <a-form-item v-if="packDataModel.jingjia_way==='1' && packDataModel.offer_type!='1'"
                           :label="packDataModel.jingjia_type==='1'?'加价幅度':'减价幅度'">
                          <span class="d-inline-block">
                            <a-input-number :placeholder="packDataModel.jingjia_type==='1'?'加价幅度':'减价幅度'"
                                            style="width: 250px"
                                            v-decorator="['pricePer',{ initialValue:packDataModel.price_per,rules: [{ required: isRequired, message: '请输入价格幅度' }]}]"
                                            :min="0"
                                            :precision="2"
                                            :max="100"/>
                          </span>
                          <span class="d-inline-block" style="margin-left: 10px">%</span>
                        </a-form-item>
                        <a-form-item v-if="packDataModel.jingjia_way==='2' || packDataModel.jingjia_way==='3'" label="成交规则">
                            <a-radio-group
                                    @change="e=> dealRuleChange(e.target.value)"
                                    v-decorator="['dealRule',{initialValue:packDataModel.deal_rule}]">
                                <a-radio value="1">先报价者成交</a-radio>
                                <a-radio value="2">系统抽签</a-radio>
                            </a-radio-group>
                        </a-form-item>
                        <span style="color:red" v-if="packDataModel.jingjia_way=='2' && packDataModel.deal_rule=='2'">你选择的是系统抽签，若存在40个以上相同报价情况，请谨慎选择</span>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="24">
                        <a-divider class="color-orange" orientation="left">废标条件</a-divider>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="购标供应商">
                            <span class="d-inline-block" style="margin-right: 10px">不少于</span>
                            <span class="d-inline-block">
                            <a-input-number
                                    v-decorator="['leastSupNum',{initialValue:packDataModel.least_sup_num, rules: [{ required: isRequired, message: '请输数量' }]}]"
                                    :min="1"
                                    :precision="0"
                            />
                                          </span>
                            <span class="d-inline-block" style="margin-left: 10px">家</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="报价供应商">
                            <span class="d-inline-block" style="margin-right: 10px">不少于</span>
                            <span class="d-inline-block">
                            <a-input-number
                                    v-decorator="['joinSupNum',{initialValue:packDataModel.join_sup_num, rules: [{ required: isRequired, message: '请输数量' }]}]"
                                    :min="1"
                                    :precision="0"
                            />
                                                </span>
                            <span class="d-inline-block" style="margin-left: 10px">家</span>
                        </a-form-item>
                    </a-col>
                </a-row>
                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="24">
                        <a-divider class="color-orange" orientation="left">相关费用</a-divider>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="平台服务费">
                            <a-radio-group :disabled="xmjn === '2'?false:true" @change="e=> isRegFeeChange(e.target.value)"
                                           v-decorator="['isRegFee',{initialValue:packDataModel.is_reg_fee}]">
                                <a-radio value="1">缴纳</a-radio>
                                <a-radio value="0">不缴纳</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="平台服务费金额" v-if="packDataModel.is_reg_fee==='1'">
                               <span class="d-inline-block">
                            <a-input-number placeholder="平台服务费金额" :disabled="xmjn === '2'?false:true" style="width: 250px"
                                            v-decorator="['regFee',{initialValue:packDataModel.reg_fee, rules: [{ required: isRequired, message: '请输入平台服务费金额' }]}]"
                                            :min="0"
                                            :precision="2"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">元</span><span style="color: red" v-show="xmjn === '1'">（按项目收取购标费）</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="保证金">
                            <a-radio-group @change="e=> isPayChange(e.target.value)"
                                           v-decorator="['isPay',{initialValue:packDataModel.is_pay}]">
                                <a-radio value="1">缴纳</a-radio>
                                <a-radio value="0">不缴纳</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item v-if="packDataModel.is_pay==='1'" label="保证金金额">
                            <span class="d-inline-block">
                            <a-input-number placeholder="保证金金额" style="width: 250px"
                                            v-decorator="['deposit',{initialValue:packDataModel.deposit, rules: [{ required: isRequired, message: '请输入保证金金额' }]}]"
                                            :min="0"
                                            :precision="2"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">元</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="成交服务费">
                            <a-radio-group @change="e=> isServiceChange(e.target.value)"
                                           v-decorator="['isService',{initialValue:packDataModel.is_service}]">
                                <a-radio value="1">缴纳</a-radio>
                                <a-radio value="0">不缴纳</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="缴纳者" v-if="packDataModel.is_service==='1'">
                            <a-radio-group
                                    v-decorator="['payer',{initialValue:packDataModel.payer}]">
                                <a-radio value="1">成交供应商</a-radio>
                                <a-radio value="2">采购人</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="成交服务费计算" v-if="packDataModel.is_service==='1'">
                            <a-radio-group @change="e=> serviceWayChange(e.target.value)"
                                           v-decorator="['serviceWay',{initialValue:packDataModel.service_way}]">
                                <a-radio value="1">基准费率</a-radio>
                                <a-radio value="2">基准费率下浮</a-radio>
                                <a-radio value="3">基准费率上浮</a-radio>
                                <a-radio value="4">定额收费</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11" v-if="packDataModel.service_way==='2'">
                        <a-form-item label="下浮率" >
                              <span class="d-inline-block">
                            <a-input-number placeholder="下浮率" style="width: 250px"
                                            v-decorator="['rate',{initialValue:packDataModel.rate, rules: [{ required: isRequired, message: '请输入下浮率' }]}]"
                                            :min="0"
                                            :precision="2"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">%</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11" v-if="packDataModel.service_way==='3'">
                        <a-form-item label="上浮率" >
                           <span class="d-inline-block">
                            <a-input-number placeholder="上浮率" style="width: 250px"
                                            v-decorator="['rate',{initialValue:packDataModel.rate, rules: [{ required: isRequired, message: '请输入上浮率' }]}]"
                                            :min="0"
                                            :precision="2"
                            />
                            </span>
                            <span class="d-inline-block" style="margin-left: 10px">%</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11">
                        <a-form-item label="成交服务费金额" v-if="packDataModel.service_way==='4'">
                             <span class="d-inline-block">
                            <a-input-number placeholder="成交服务费金额" style="width: 250px"
                                            v-decorator="['servicePrice',{ initialValue:packDataModel.service_price,rules: [{ required: isRequired, message: '请输入金额' }]}]"
                                            :min="0"
                                            :precision="2"
                                            :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
                            />
                                       </span>
                            <span class="d-inline-block" style="margin-left: 10px">元</span>
                        </a-form-item>
                    </a-col>
                    <a-col :span="11" v-if="packDataModel.is_service==='1'">
                        <a-form-item label="服务费额外计税" >
                            <a-radio-group
                                    v-decorator="['ewjs',{initialValue:packDataModel.ewjs}]">
                                <a-radio value="1">需额外计税</a-radio>
                                <a-radio value="0">不计税</a-radio>
                            </a-radio-group>
                        </a-form-item>
                    </a-col>
                </a-row>

                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="24">
                        <a-divider class="color-orange" orientation="left">标的物信息</a-divider>
                    </a-col>
                    <a-table  style="width: 100%"
                            :dataSource="packItems"
                            :rowKey="record => record.id"
                            :pagination="false">

                        <a-table-column key="indexNum" width="5%" title="序号">
                            <template slot-scope="text,record,index">{{index+1}}</template>
                        </a-table-column>
                        <a-table-column  key="subjectName" width="20%" title="名称" data-index="subjectName">
                            <template slot-scope="text,record">
                            <a-input key="subjectName" :value="record.subjectName" style="margin: -5px 0"
                                     placeholder="名称"
                                     @change="e => onEditPackItem(e.target.value, record.id, 'subjectName')"/>
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType==='1'" key="specifications" width="20%" title="品牌及规格型号"
                                        data-index="specifications">
                            <template slot-scope="text,record">
                            <a-input key="specifications" :value="record.specifications" style="margin: -5px 0"
                                     placeholder="规格型号"
                                     @change="e => onEditPackItem(e.target.value, record.id, 'specifications')"/>
                            </template>
                        </a-table-column>

                        <a-table-column v-if="tenderType==='1'" key="quantity" width="10%" title="数量" data-index="quantity">
                            <template slot-scope="text,record">
                            <a-input-number key="quantity" :value="record.quantity" style="margin: -5px 0;width: 100%"
                                            placeholder="数量" :min="1"
                                            @change="value => onEditPackItem(value, record.id, 'quantity')"/>
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType==='1'" key="unit" width="10%" title="单位" data-index="unit">
                            <template slot-scope="text,record">
                            <a-input key="unit" :value="record.unit" style="margin: -5px 0"
                                     placeholder="单位"
                                     @change="e => onEditPackItem(e.target.value, record.id, 'unit')"/>
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType!=='1'" key="serviceScope" width="25%" :title="(tenderType!=='1' && tenderType==='2')?'施工范围':'简要服务内容'" data-index="serviceScope">
                            <template slot-scope="text,record">
                                <a-input  key="serviceScope" :value="record.serviceScope" style="margin: -5px 0"
                                         @change="e => onEditPackItem(e.target.value, record.id, 'serviceScope')"/>
                            </template>
                        </a-table-column>
                        <a-table-column v-if="tenderType==='2' || tenderType==='3'" key="servicePeriod" width="15%" :title="(tenderType!=='1' && tenderType==='2')?'施工工期':'服务期限'" data-index="servicePeriod">
                            <template slot-scope="text,record">
                                <a-input  key="servicePeriod" :value="record.servicePeriod" style="margin: -5px 0"
                                         @change="e => onEditPackItem(e.target.value, record.id, 'servicePeriod')"/>
                            </template>
                        </a-table-column>
                        <a-table-column key="ask" width="25%" title="其他要求" data-index="ask">
                            <template slot-scope="text,record">
                             <a-input style="margin: -5px 0;width: 100%" :value="record.ask"
                                       placeholder="其他要求"
                                       @change="e => onEditPackItem(e.target.value, record.id, 'ask')"/>
                            </template>
                        </a-table-column>

                        <a-table-column key="operation" width="10%" title="操作">
                            <template slot-scope="text,record">
                            <a-popconfirm title="是否要删除此行？" @confirm="onRemovePackItem(record.id)">
                                <a>删除</a>
                            </a-popconfirm>
                            </template>
                        </a-table-column>


<!--                        -->
<!--                        <template slot="subjectName" slot-scope="text, record">-->
<!--                            <a-input key="subjectName" :value="record.subjectName" style="margin: -5px 0"-->
<!--                                     placeholder="名称"-->
<!--                                     @change="e => onEditPackItem(e.target.value, record.id, 'subjectName')"/>-->
<!--                        </template>-->
<!--                        <template slot="specifications" slot-scope="text, record">-->
<!--                            <a-input key="specifications" :value="record.specifications" style="margin: -5px 0"-->
<!--                                     placeholder="规格型号"-->
<!--                                     @change="e => onEditPackItem(e.target.value, record.id, 'specifications')"/>-->
<!--                        </template>-->
<!--                        <template slot="quantity" slot-scope="text, record">-->
<!--                            <a-input-number key="quantity" :value="record.quantity" style="margin: -5px 0;width: 100%"-->
<!--                                            placeholder="数量" :min="1"-->
<!--                                            @change="value => onEditPackItem(value, record.id, 'quantity')"/>-->
<!--                        </template>-->
<!--                        <template slot="unit" slot-scope="text, record">-->
<!--                            <a-input key="unit" :value="record.unit" style="margin: -5px 0"-->
<!--                                     placeholder="单位"-->
<!--                                     @change="e => onEditPackItem(e.target.value, record.id, 'unit')"/>-->
<!--                        </template>-->
<!--                        <template slot="ask" slot-scope="text, record">-->
<!--                            <a-input style="margin: -5px 0;width: 100%" :value="record.ask"-->
<!--                                     @click="e => openEdit(e.target.value,record.id, 'ask')" placeholder="其他要求"-->
<!--                                     @change="e => onEditPackItem(e.target.value, record.id, 'ask')"/>-->
<!--                        </template>-->
<!--                        <template slot="ask" slot-scope="text, record">-->
<!--                            <a-input style="margin: -5px 0;width: 100%" :value="record.ask"-->
<!--                                     placeholder="其他要求"-->
<!--                                     @change="e => onEditPackItem(e.target.value, record.id, 'ask')"/>-->
<!--                        </template>-->
<!--                        <template slot="operation" slot-scope="text, record">-->
<!--                            <a-popconfirm title="是否要删除此行？" @confirm="onRemovePackItem(record.id)">-->
<!--                                <a>删除</a>-->
<!--                            </a-popconfirm>-->
<!--                        </template>-->
                    </a-table>
                    <a-button
                              style="width: 100%; margin-top: 16px; margin-bottom: 8px" type="dashed" icon="plus"
                              @click="onAddPackItem">新增标的物
                    </a-button>
                </a-row>
                <a-row type="flex" justify="space-between" class="form-input about">
                    <a-col :span="24">
                        <a-divider class="color-orange" orientation="left">备注</a-divider>
                    </a-col>
                    <a-col :span="24">
                        <a-form-item label="其他说明">
                            <a-textarea
                                    placeholder="其他说明"
                                    :auto-size="{ minRows: 2, maxRows: 6 }"
                                    v-decorator="['otherRemarks',{initialValue:packDataModel.other_remarks}]"/>
                        </a-form-item>
                    </a-col>
                </a-row>
            </a-form>

<!--            <div>-->
<!--                <a-modal-->
<!--                        :title="textModel.rowColumn=='ask'?'其他要求':'备注'"-->
<!--                        v-model="showEditModal"-->
<!--                        @ok="onShowEditModalOk"-->
<!--                >-->
<!--                    <a-form-item :label="textModel.rowColumn=='ask'?'其他要求':'备注'">-->
<!--                        <a-input hidden v-model="textModel.rowId"></a-input>-->
<!--                        <a-input hidden v-model="textModel.rowColumn"></a-input>-->
<!--                        <a-textarea style="height:120px;" v-model="textModel.textMsg"></a-textarea>-->
<!--                    </a-form-item>-->
<!--                </a-modal>-->
<!--            </div>-->
            <div>
                <a-modal
                        title="标的物删除"
                        v-model="showDelModal"
                        @ok="onShowDelModalOk"
                >
                    <p>至少填写一个标的物！</p>
                </a-modal>
            </div>
            <choose-purchase-type ref="choosePurchaseTypeRef" :visible="choosePurchaseTypeVisible" @success="choosePurchaseTypeSuccessMethod" @cancel="choosePurchaseTypeCancelMethod" ></choose-purchase-type>
        </a-card>
        </a-spin>
    </page-view>
</template>

<script>
  import { PageView } from '@/layouts'
  import DictCascader from '@/components/dict/DictCascader'
  import moment from 'moment'
  import qs from 'qs'
  import ChoosePurchaseType from './ChoosePurchaseType'

  const uuidv4 = require('uuid/v4')

  export default {
    name: 'PackEdit',
    props: ['visible', 'projectId', 'tenderType','packId','isRequired','indexNum', 'xmjn', 'cgwjsj'],
    components: {
      PageView,
      DictCascader,
      'choose-purchase-type':ChoosePurchaseType
    },
    data () {
      return {
        choosePurchaseTypeVisible:false,
        spinning:true,
        checked: true,
        // textModel: {
        //   textMsg: '',
        //   rowId: '',
        //   rowColumn: ''
        // },
       // showEditModal: false,
        showDelModal: false,
        packDataModel: {
          // duration: '',
          // price_start: '',
          // service_price: '',
          // deposit: ''
        },
        packEditForm: this.$form.createForm(this),
        loading: false,
        // columns: [
        //   {
        //     title: '名称',
        //     width: '250px',
        //     scopedSlots: { customRender: 'subjectName' }
        //   },
        //   {
        //     title: '品牌及规格型号',
        //     width: '250px',
        //     scopedSlots: { customRender: 'specifications' }
        //   },
        //   {
        //     title: '数量',
        //     width: '100px',
        //     scopedSlots: { customRender: 'quantity' },
        //
        //   },
        //   {
        //     title: '单位',
        //     width: '100px',
        //     scopedSlots: { customRender: 'unit' },
        //
        //   },
        //   // {
        //   //   title: '其他要求',
        //   //   scopedSlots: { customRender: 'ask' },
        //   //   width: '300px',
        //   // },
        //   {
        //     title: '其他要求',
        //     scopedSlots: { customRender: 'ask' },
        //     width: '400px',
        //   },
        //   {
        //     title: '操作',
        //     width: '80px',
        //     scopedSlots: { customRender: 'operation' }
        //   }
        // ],
        packItems: []
      }
    },
    created () {

    },
    watch: {
      tenderType: {
        immediate: false,
        handler (newValue, oldValue) {

          if (newValue !== oldValue) {
            this.packItems=[]
            this.onAddPackItem()
            console.log(newValue+"1111")
          }
        }
      }
    },
    mounted(){
      this.packData()
    },
    methods: {
      //设置报价类型
    onChangeOfferType(val, field){
      if(val=='2'){
        this.packDataModel.jingjia_type = '2'
        this.packEditForm.setFieldsValue({
          jingjiaType: '2'
        })
      }
      if(val=='3'){
        this.packDataModel.jingjia_type = '1'
        this.packEditForm.setFieldsValue({
          jingjiaType: '1'
        })
      }
      this.packDataModel[field] = val
    },
      isRegFeeChange(val) {
        this.packDataModel.is_reg_fee = val
      },
      isServiceChange(val) {
        if ("0"===val)
        {
          this.packDataModel.service_way =''
        }else {
          this.packDataModel.service_way ='1'
          this.packDataModel.payer='1'
        }
        this.packDataModel.is_service = val

      },
      serviceWayChange(val) {
        this.packDataModel.service_way = val
      },
      isPayChange (val) {
        this.packDataModel.is_pay = val
      },
      jingjiaTypeChange(val)
        {
          this.packDataModel.jingjia_type = val
        },
      jingjiaWayChange(val)
      {
        this.packDataModel.jingjia_way = val
        // if (val==='2'){
        //  this.packEditForm.setFieldsValue({
        //    "countDown":''
        //  })
        //   this.packDataModel.count_down=''
        //}
      },
      //是否需要详细报价表
      jingjiaDetailChange(val) {
        this.packDataModel.jingjia_detail = val
      },
      //是否需要上传报价过程确认函
      quotationConfirmChange(val){
        this.packDataModel.quotation_confirm = val
      },
      dealRuleChange(val){
        this.packDataModel.deal_rule = val
      },
      packSubData (packId,projectId) {
        const that = this
        that.$http.get('/api/1/apply/getBidPacksSubList.json?projectId=' + projectId + '&packId=' + packId).then(function (response) {
          const result = response.result
          that.packItems = []
          if (result.length > 0) {
            that.packItems = result
          } else {
            that.onAddPackItem()
          }
          that.spinning =false
          that.$nextTick(function () {
            if (that.isRequired) {
              that.packEditForm.validateFields((err, values) => {
              })
            }
          })

        })

      },
      // openEdit (value, id, column) {
      //   this.textModel.rowId = id
      //   this.textModel.rowColumn = column
      //   this.textModel.textMsg = value
      //   this.showEditModal = true
      // },
      // onShowEditModalOk () {
      //   this.showEditModal = false
      //   this.onEditPackItem(this.textModel.textMsg, this.textModel.rowId, this.textModel.rowColumn)
      // },
      onAddPackItem () {
        let that = this
        that.packItems.push({
          id: uuidv4(),
          projectId: that.packDataModel.projectId,
          packId: that.packDataModel.id,
          subjectName: '',
          specifications: '详见采购需求',
          createTime: moment(),
          quantity: '',
          unit: '',
          ask: '详见采购需求',
          remarks: '',
          serviceScope:'详见采购需求',
          servicePeriod:''
        })
        console.log( that.packItems)
      },
      onShowDelModalOk () {
        this.showDelModal = false
      },
      onRemovePackItem (id) {
        if (this.packItems.length < 2) {
          this.showDelModal = true
        } else {
          const newData = this.packItems.filter(item => item.id !== id)
          this.packItems = newData
        }
      },
      onEditPackItem (value, id, column) {
        const newData = [...this.packItems]
        const target = newData.filter(item => id === item.id)[0]
        if (target) {
          target[column] = value
          this.packItems = newData
        }
      },
      // 校验编码
      onChangeCode (e) {
        this.checkCode(e.target.value, '1')
      },
      checkCode (packCode, val) {
        const arr = []
        let that = this
        that.$http.get('/api/1/apply/checkPackCode.json?packId=' + that.packDataModel.id + '&packCode=' + packCode).then(function (response) {
          if (response.code !== 200) {
            return
          }
          if (response.result > 0) {
            arr.push({
              message: '您输入的包组编号已存在，请更换!',
              field: 'packCode'
            })
            that.packEditForm.setFields({ packCode: { value: packCode, errors: arr } })
          } else {
            if (val !== '1') {
              that.packDataSave()
            }
          }
        })
      },
      packData () {
        const that = this
        that.$http.get('/api/1/apply/getBidPackInfo.json?projectId=' + that.projectId + '&packId=' + that.packId).then(function (response) {
          that.reset()
          const result = response.result
          that.packDataModel = result
          that.packSubData(that.packId, that.projectId)
          //console.log(that.packDataModel)
        })
      },
      reset () {
        this.packEditForm.resetFields()
        this.model = {}
      },
      onSave () {
        let that = this
        that.packEditForm.validateFields((err, values) => {
          if (err) {
            return
          }
          if (values.joinSupNum>values.leastSupNum)
          {
            that.$message.error('报价供应商家数不能大于购标供应商家数！')
            return
          }
          that.packDataSave()
        //  that.checkCode(values.packCode)
        })
      },
      packDataSave () {
        const that = this

        let packData = that.packEditForm.getFieldsValue()
        packData.id = that.packDataModel.id
        packData.items = that.packItems
        packData.projectId = that.packDataModel.projectId
        let subMessage =''
        if (that.isRequired ){
        for (let i = 0; i < packData.items.length ; i++) {
          if (that.tenderType==='1'){
            if (!packData.items[i].subjectName || !packData.items[i].specifications || !packData.items[i].quantity || !packData.items[i].unit)
            {
              subMessage = subMessage+(i+1)+',';
            }
          }else if (that.tenderType==='2' || that.tenderType==='3')
          {
            if (!packData.items[i].subjectName || !packData.items[i].serviceScope)
            {
              subMessage = subMessage+(i+1)+',';
            }
          }
        }
        if (subMessage)
        {
          that.$message.error('标的物第'+subMessage.substring(0,subMessage.lastIndexOf(','))+'行信息不全，请补全！')
          return
        }
        }
        that.loading=true
        // packData.projectName = that.packDataModel.project_name
        // packData.projectCode = that.packDataModel.project_code
        //console.log(packData)
        this.$http.post('/api/1/apply/updateBidPack.json', qs.stringify(packData, { allowDots: true })).then(function (response) {
          if (response.code !== 200) {
            that.$message.error('编辑失败')
            return
          }
          that.$message.success('编辑包组成功')
          that.loading=false
          that.$emit('success')
        })
      },


      //打开选择采购品目的页面
      openChoosePurchaseTypeMethod(){
            this.choosePurchaseTypeVisible=true;
            let json=[];
            let purchaseType=this.packEditForm.getFieldValue("purchaseType");
            let purchaseTypeName=this.packEditForm.getFieldValue("purchaseTypeName");
            if(purchaseType){
                let typeNames=purchaseTypeName.split("/");
                let types=purchaseType.split("/");
                for(let i=0;i<types.length;i++){
                    let customJson={
                        "fid":types[i],
                        "fspmmc": typeNames[i]
                    };
                    json.push(customJson);
                }
            }
            this.$refs.choosePurchaseTypeRef.preView(json);
      },
      //采购品目页面成功返回的代码
      choosePurchaseTypeSuccessMethod(userSelectContent){
            let purchaseType="";
            let purchaseTypeName="";
            for(let i=0;i<userSelectContent.length;i++){
                purchaseType+=userSelectContent[i].fid;
                purchaseTypeName+=userSelectContent[i].fspmmc;
                if(i!=userSelectContent.length-1){
                    purchaseType+="/";
                    purchaseTypeName+="/";
                }
            }
             this.packEditForm.setFieldsValue({
                    purchaseType:purchaseType,
                    purchaseTypeName:purchaseTypeName
            });
             this.choosePurchaseTypeVisible=false;

      },
      //采购品目页面关闭窗口返回的代码
      choosePurchaseTypeCancelMethod(){
            this.choosePurchaseTypeVisible=false;
      },
    }
  }
</script>

<style lang="less" scoped>
    /deep/ .page-header {
        border-bottom: none;
        padding: 0;
    }

    /deep/ .page-header .breadcrumb {
        display: none;
    }

    /deep/ .content{
        margin: 0 24px;
    }

</style>
